<template>
  <div class="dashboard_right absolute">
    <!-- 按钮蒙层 -->
    <div v-if="!equip_data.is_iot_ready" class="overlay">
      <button type="button" class="btn btn-info waves-effect waves-light">
        <span>{{ $t("建议进行IOT升级") }}</span>
      </button>
    </div>
    <div style="height: 100%">
      <!-- 整站面板 -->
      <!-- <div class="dashboard-panel" v-if="topList.length">
        <div class="electric">
          <label>{{ electricName }}</label>
          <div class="cont">
            <span class="value">{{ electric }}</span>
            <span class="unit">{{['A','A','KW'][($route.query.index-1)||0]}}</span>
  
          </div>
        </div>
        <div class="pressure">
          <label>{{pressureName}}</label>
          <div class="cont">
            <span class="value">{{ pressure }}</span>
            <span class="unit">{{['kPaG','mbarA','mbarG'][($route.query.index-1)||0]}}</span>
          </div>
        </div>
      </div> -->
      <div class="dashboard-panel">
        <div
          class="electric"
          :style="`${
            topIndex.length > 0 ? 'border-right: 1px solid #fff;' : ''
          }`"
        >
          <div>{{
            topIndex.length > 0 ? topLeft && topLeft.name : ""
          }}</div>
          <div class="cont">
            <span class="value" v-if="equip_data.is_iot_ready">{{
              topIndex.length > 0 ? topLeft && topLeft.v : ""
            }}</span>
            <span class="unit">{{
              topIndex.length > 0 ? topLeft && topLeft.unit : ""
            }}</span>
          </div>
        </div>
        <div class="pressure">
          <div>{{
            topIndex.length > 0 ? topRight && topRight.name : ""
          }}</div>
          <div class="cont">
            <span class="value" v-if="equip_data.is_iot_ready">{{
              topIndex.length > 0 ? topRight && topRight.v : ""
            }}</span>
            <span class="unit">{{
              topIndex.length > 0 ? topRight && topRight.unit : ""
            }}</span>
          </div>
        </div>
      </div>

      <div class="right_contain" style="height: calc(100% - 102px)">
        <div class="d-flex align-items-center">
          <p
            style="
              border-radius: 1.25rem 1.25rem 0 0;
              background-color: rgba(0, 0, 0, 0.5);
            "
            class="w-100 p-2 m-0 d-flex align-items-center"
            data-bs-toggle="dropdown"
            data-bs-auto-close="outside"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{ $t("Customise_Dashboard") }}<i class="ri-arrow-down-s-line"> </i>
          </p>

          <div
            class="dropdown-menu dropdown-menu-end dropdown_box"
            aria-labelledby="dropdownMenuClickableInside"
            style="
              width: 430px;
              color: #fff;
              z-index: 1;
              padding: 10px 0px;
              border-radius: 1.25rem;
              background: linear-gradient(
                152deg,
                rgba(49, 46, 46, 0.4) 0%,
                rgba(69, 68, 65, 0.4) 100%
              );
              box-shadow: 0px 1.25rem 3.8125rem 0px rgba(16, 20, 28, 0.6);
              border-top: 0.0625rem solid #b6b7bc3f;
              border-left: 0.0625rem solid #b6b7bc3f;
              border-right: 0.0625rem solid #b6b7bc3f;
              height: 350px;
            "
          >
            <div class="h-100 w-100">
              <div>
                <p class="mb-0" style="font-size: 16px; margin-left: 20px">
                  {{ $t("overview_static.device_page.add_more_data") }}
                </p>
                <img src="./icon-divider.svg" alt="" />
              </div>
              <div
                id="cockpitTree"
                data-simplebar
                data-simplebar-auto-hide="false"
                style="
                  overflow: auto;
                  width: 100%;
                  height: calc(100% - 60px);
                  max-height: calc(100% - 60px);
                "
              >
              <!-- v-if="isPaperMaking" -->
                <cockpitTreeStarGroupPaperMaking
                  v-model:dataList="selectCheckedList"
                  @saveInstancesSetting="saveInstancesSetting"
                  @changeStarStat="changeStarStat"
                  :topIndex="topIndex"
                  :chartIndex="chartIndex"
                />
                <!-- <cockpitTreeStar
                  v-else
                  v-model:dataList="selectCheckedList"
                  @saveInstancesSetting="saveInstancesSetting"
                  @changeStarStat="changeStarStat"
                  :topIndex="topIndex"
                  :chartIndex="chartIndex"
                /> -->
              </div>
            </div>
          </div>
        </div>
        <div
          class="children"
          :style="{ height: equip_data.name === 'NEV2 070' ? '50%' : '95%' }"
        >
          <!-- 公共title -->
          <Top :name="name" :show-button="false" class="mb-2"></Top>
          <div
            v-if="chartType"
            class="scroll-model"
            style="overflow: auto; height: calc(100% - 60px)"
          >
            <div
              v-for="a in chartlists"
              :key="a.data.id"
              v-show="
                a.list.length > 0 &&
                a.list.filter((item) => {
                  return chartIndex.includes(item.equipment_id_key);
                }).length > 0
              "
            >
              <div class="d-flex">
                <a
                  :href="`${'#A' + a.data.id}`"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  :aria-controls="a.data.id"
                  :data-key="a.name"
                  class="text-dark"
                  @click="changeType(a)"
                >
                  <i style="margin-left: 20px"></i>
                  <i
                    :class="[
                      'fs-12',
                      a.iconType ? ' bx bxs-down-arrow' : 'bx bxs-right-arrow',
                    ]"
                    style="color: #fff; position: absolute; top: 3px; left: 5px"
                  ></i>
                </a>
                <div
                  style="
                    display: inline-block;
                    width: 90%;
                    display: flex;
                    align-items: center;
                    align-content: center;
                  "
                >
                  <span>{{ a.data.name }}</span>
                </div>
              </div>
              <div :class="['collapse', 'show']" :id="'A' + a.data.id">
                <ShockData
                  :equip_data="a.data"
                  :chartlist="a.list"
                  :chartIndex="chartIndex"
                ></ShockData>
              </div>
            </div>
          </div>
        </div>
        <!-- <div
          id="mapBoxs"
          style="
            width: 100%;
            height: 40%;
            margin-top: 10px;
            border-radius: 10px;
          "
        ></div> -->
        <div class="children status" v-if="false">
          <Status></Status>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Select from "../Select";
import AMapLoader from "@amap/amap-jsapi-loader";

import ShockData from "./component/ShockDataGroup.vue";
import Status from "./component/Status.vue";
import moment from "moment";
// import { valueFormatter } from "../../utils/common.js";
// import cockpitTreeStar from "@/components/cockpitTreeStarGroup.vue";
import cockpitTreeStarGroupPaperMaking from "@/components/cockpitTreeStarGroupPaperMaking.vue";
// import _ from "loadsh";
export default {
  props: {
    isShowEcharts: {
      type: Boolean,
      required: true,
    },
    equip_data: {
      type: Object,
      required: true,
    },
    chartlist: {
      type: Array,
      required: true,
    },
    equip_data_info_list: {
      type: Array,
      required: true,
    },
    chartlists: {
      type: Array,
      required: true,
    },
  },
  emits: ["topIndexEvent"],
  data() {
    return {
      chartType: true,
      retryCount: 0,
      dataList: [],
      topIndex: [] /* 置顶展示两个测点信息 */,
      chartData: [],
      chartIndex: [] /* echarts展示情况 */,
      electricName: "功率",
      pressureName: "出口压力",
      option_show: false,
      ImageList: {
        dropdown: require("@/assets/icon-font/icon-dropdown.svg"),
      },
      defaultProps: { children: "children", label: "name" },
      electric: 35.01,
      pressure: -94,
      currentChecked: "data",
      timer: null,
      //造纸厂，机组固定展示T1
      paper_making_ids:[
        "3a0e4c90-1420-11f0-8da8-0d1c443f2d5f", //EP600,T3
        "4ffc20f0-dfdf-11f0-b610-85349516fd91" //EP1000,T3
      ],
    };
  },
  computed: {
    //造纸厂展示内容
    isPaperMaking(){
      return this.$store.state.equipManagement.isDemonstrationPaperMaking;
    },
    topLeft() {
      let obj = {};
      // if (this.topIndex.length === 1 || this.topIndex.length === 2) {
      //   return this.topIndex[0];
      // } else if (this.topIndex.length > 2) {
      //   const filteredList = this.topIndex.filter((a) => a.name !== "压力");
      //   if (filteredList.length > 0) {
      //     const current = filteredList.find((a) => a.name === "电流");
      //     return current || filteredList[0];
      //   }
      // }
      this.chartlists.map((newData) => {
        newData.list.map((item) => {
          if(this.isPaperMaking){
            if (this.paper_making_ids.includes(item.equipment_id) && this.topIndex[0] && this.topIndex[0].equipment_id_key === item.equipment_id_key) {
              obj = item;
            }
          }else{
            if (this.topIndex[0] && this.topIndex[0].id === item.id) {
              obj = item;
            }
          }
        });
      });
      return obj;
    },

    topRight() {
      // const length = this.topIndex.length;
      // if (length === 2) {
      //   return this.topIndex[1];
      // } else if (length === 1) {
      //   return {};
      // } else if (length > 2) {
      //   const filteredList = this.topIndex.filter((a) => a.name !== "电流");

      //   if (filteredList.length > 0) {
      //     const pressureItem = filteredList.find((a) => a.name === "压力");
      //     return pressureItem || filteredList[1];
      //   } else {
      //     return {};
      //   }
      // } else {
      //   return {};
      // }
      let obj = {};
      this.chartlists.map((newData) => {
        newData.list.map((item) => {
          if(this.isPaperMaking){
            if (this.paper_making_ids.includes(item.equipment_id) && this.topIndex[1] && this.topIndex[1].equipment_id_key === item.equipment_id_key) {
              obj = item;
            }
          }else{
            if (this.topIndex[1] && this.topIndex[1].id === item.id) {
              obj = item;
            }
          }
        });
      });
      return obj;
    },
    name() {
      return this.$t("Unit Real-time Operation Data");
    },
    numView() {
      return this.$route.query.index || 1;
    },
    selectCheckedList() {
      var list = [];
      if (this.equip_data_info_list.length > 0) {

        list = this.equip_data_info_list || [this.equip_data];
      } else {
        list.push(this.equip_data);
      }
      
      // var su
      // this.recursionArr(list).forEach(i=>{
      //   console.log(this.topIndex,"this.topIndexthis.topIndexthis.topIndex");
      //   if(i.attributes&&i.attributes.measurements){
      //       i.attributes.measurements.forEach((item,index)=>{
      //         if(this.topIndex[0]==index || this.topIndex[1]==index ){ //默认展示电流，电压
      //           item.isShow = true
      //         }else{
      //           item.isShow = false
      //         }
      //       })
      //     }
      // })
      return this.recursionArr(list);
    },
    selectChecked() {
      let selectData = [];
      if (window.localStorage.getItem("selectChecked")) {
        selectData = JSON.parse(window.localStorage.getItem("selectChecked"));
      } else {
        selectData = [
          { name: "振动数据", checked: true, disabled: false },
          {
            name: "状态",
            checked: true,
            disabled: false,
          },
        ];
      }
      window.localStorage.setItem("selectChecked", JSON.stringify(selectData));
      return selectData;
    },
  },
  watch: {
    "$i18n.locale": {
      handler(val) {
        let locale = JSON.parse(window.localStorage.getItem("selectChecked"));
        if (val == "en") {
          locale.map((item) => {
            switch (item.name) {
              case "生产节拍":
                item.name = this.$t("Takt_Time");
                break;
              case "人均分析":
                item.name = this.$t("Values_Per_Capita");
                break;
              case "今日废品分析":
                item.name = this.$t("Daily_Defects_Status");
                break;
              case "本月废品分析":
                item.name = this.$t("Monthly_Defects_Status");
                break;
            }
          });
          window.localStorage.setItem("selectChecked", JSON.stringify(locale));
        } else {
          locale.map((item) => {
            switch (item.name) {
              case "Cycle Time":
                item.name = "生产节拍";
                break;
              case "Values Per Capita":
                item.name = "人均分析";
                break;
              case "Daily Defects Status":
                item.name = "今日废品分析";
                break;
              case "Monthly Defects Status":
                item.name = "本月废品分析";
                break;
            }
          });
          window.localStorage.setItem("selectChecked", JSON.stringify(locale));
        }
      },
      deep: true,
    },
    // chartlists: {
    //   handler(newVal, oldVal) {
    //     if (newVal.length > 0&&newVal.length != oldVal.length) {
    // this.changeList()

    //     }
    //   },
    //   deep: true,
    // },
    
  },
  unmounted() {
    clearInterval(this.timer);
  },
  mounted() {
    
    this.getMapToken();
    // this.chartData = _.cloneDeep(this.chartlist)

    /* 设备默认状态下2个top状态 */

    // this.timer = setInterval(() => {
    //   if(this.$route.query.index==1){
    //     this.pressure = this.randoms(-94, -98);
    //     this.electric = this.randoms(35.01, 36.5);
    //     this.electricName = '机组运行电流'
    //     this.pressureName = '机组吸气压力'
    //   }else if(this.$route.query.index==2){
    //     this.pressure = this.randoms(9, 10);
    //     this.electric = this.randoms(35.01, 36.5);
    //     this.electricName = '机组运行电流'
    //     this.pressureName = '机组吸气压力'
    //   }else{
    //     this.pressure = this.randoms(700, 950);
    //     this.electric = this.randoms(170, 202);
    //     this.electricName = '功率'
    //     this.pressureName = '出口压力'
    //   }

    // }, 1000);
    this.changeList();
  },
  methods: {
    sortedItems(arr) {
      return arr.sort((a, b) => {
        const order = ["电流", "压力"];
        const indexA = order.indexOf(a.name);
        const indexB = order.indexOf(b.name);

        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        } else if (indexA !== -1) {
          return -1;
        } else if (indexB !== -1) {
          return 1;
        } else {
          return a.name.localeCompare(b.name);
        }
      });
    },
    changeList() {
      this.topIndex = [];
    let  a = 0,
          b = 0;
      this.chartlists.map((newData) => {
        let length = newData.list.length
          // aId = "",
          // bId = "",
      
        if (length > 0) {
          newData.list.map((item) => {
            if(this.isPaperMaking){
                if ( this.paper_making_ids.includes(item.equipment_id)&&item.name === "总脱水量") {
                  a += 1; //只添加一次
                  if (a == 1) {
                    this.topIndex.push(item);
                    // aId = item.id;
                  }
                }
                if ( this.paper_making_ids.includes(item.equipment_id)&&item.name === "透平机真空度") {
                  b += 1; //只添加一次
                  if (b == 1) {
                    this.topIndex.push(item);
                    // bId = item.id;
                  }
                }
            }else{
              if (item.name === "电流") {
                a += 1; //只添加一次
                if (a == 1) {
                  this.topIndex.push(item);
                  // aId = item.id;
                }
              }
              if (item.name === "压力") {
                b += 1; //只添加一次
                if (b == 1) {
                  this.topIndex.push(item);
                  // bId = item.id;
                }
              }
            }
          });
          // if (a + b === 0) {
          //   if (length === 1 && length > 0) {
          //     this.topIndex = this.topIndex.concat([newData.list[0]]);
          //   } else if (length > 1) {
          //     this.topIndex = this.topIndex.concat([
          //       newData.list[0],
          //       newData.list[1],
          //     ]);
          //   }
          // }
          // if (a + b === 1) {
          //  let sublist =  newData.list.filter((it) => {
          //       return it.id != aId && it.id != bId;
          //   })
          //   if(sublist.length > 0){
          //     this.topIndex.push(sublist[0]);

          //   }
          // }
        }
        // this.$emit("topIndexEvent", this.topIndex);
        /* 设备测点折线图：默认状态下排除2个top状态*/
        // newData.data.attributes &&
        //   newData.data.attributes.measurements.forEach((item, index) => {
        //     if (index < 8) {
        //       item.is_checked = true;
        //     }
        //     this.topIndex.map((top) => {
        //       if (top.id == item.id) {
        //         item.is_checked = false;
        //       }
        //     });

        //     if (item.is_checked) {
        //       this.chartIndex.push(item.id);
        //     }
        //   });
      });
      let flag = 0;
      this.chartlists.map((newData) => {
        newData.list.map((item, index) => {
          if (this.topIndex.length === 0) {
            this.topIndex.push(item);
          }
          if (this.topIndex.length === 1 && this.topIndex[0].id != item.id) {
            this.topIndex.push(item);
          }

          if(this.isPaperMaking){
            if (this.paper_making_ids.includes(item.equipment_id) && index < 6) {
              item.is_checked = true;
            }
          }else{
            //默认展示第一台设备
            if (!this.topIndex.some(top=>top.equipment_id_key == item.equipment_id_key)&& flag < 6) {
              flag += 1;
              item.is_checked = true;
            }
          }
          this.topIndex.map((top) => {
            if (top.equipment_id_key == item.equipment_id_key) {
              item.is_checked = false;
            }
          });

          if (item.is_checked) {
            this.chartIndex.push(item.equipment_id_key);
          }
        });
      });
      
      this.chartType = false;
      this.$nextTick(() => {
        this.chartIndex = this.chartIndex.slice(0, 6);
        // this.topIndex =this.sortedItems(this.topIndex)
        this.chartType = true;
      });
    },
    changeType(item) {
      item["iconType"] = !item["iconType"];
    },
    getMapToken() {
      // let config = {
      //         headers: {
      //           "Content-Type": "application/json",
      //           Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      //         },
      //         withCredentials: true,
      //       };
      //       axios
      //         .get(
      //           this.ruluka_host +
      //             "/api/v1/"+deviceToken+"/attributes?clientKeys=Latitude,Longitude",
      //           config
      //         )
      //         .then((ress) => {
      //           console.log(ress.data.client,deviceToken);
      //           AMapLoader.reset(); //在加载地图前加一个reset方法 解决报错
      //           this.initMap(ress.data.client); //加载地图
      //         });
      this.initMap({
        Longitude: "118.43534807255436",
        Latitude: "35.34961212737784",
      });
    },
    async initMap(client) {
      await AMapLoader.load({
        key: "	d5075185b58a6bb8a0505874ae723f79", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          this.map = new AMap.Map("mapBoxs", {
            //设置地图容器id
            viewMode: "3D", //是否为3D地图模式
            zoom: 13, //初始化地图级别
            center: [client.Longitude, client.Latitude], //初始化地图中心点位置
            mapStyle: "amap://styles/darkblue", //地图的显示样式
          });
          const marker = new AMap.Marker({
            //新增一个标记点
            position: [client.Longitude, client.Latitude],
            icon: new window.AMap.Icon({
              // image: 'https://vdata.amap.com/icons/b18/1/2.png', // 自定义图标地址
              size: new window.AMap.Size(30, 40), // 图标大小
            }),
          });
          marker.setMap(this.map);
        })
        .catch((e) => {
          console.log(e);
        });
      // await AMapLoader.load({

      //   key: "d5075185b58a6bb8a0505874ae723f79", // 申请好的Web端开发者Key，首次调用 load 时必填
      //   callback: "onAPILoaded", //回调函数
      // });

      // this.map = new window.AMap.Map("mapBox", {
      //   //生成底图在mapContainer这个div里
      //   center: [client.Longitude, client.Latitude], // 初始中心点坐标
      //   zoom: 17, // 初始缩放级别
      // });
      // this.map.setMapStyle("amap://styles/darkblue");
      // // this.addMarker(client); //添加标记点的方法
    },
    addMarker(client) {
      console.log(this.map);
      this.map.setMapStyle("amap://styles/darkblue");

      this.marker = new window.AMap.Marker({
        //新增一个标记点
        position: [client.Longitude, client.Latitude],
        icon: new window.AMap.Icon({
          // image: 'https://vdata.amap.com/icons/b18/1/2.png', // 自定义图标地址
          size: new window.AMap.Size(30, 40), // 图标大小
        }),
      });
      this.marker.setMap(this.map); //放在map这个对象里面
      //顺便新增一个点击标记点出来的窗口
      this.infoWindow = new window.AMap.InfoWindow({
        //新增一个window窗口
        width: 200,
        content: "奥体中心", // 添加你想要显示的文字描述
        offset: new window.AMap.Pixel(0, -30), // 设置信息窗体偏移量，使其显示在标记点正上方
      });

      // 点击标记点时显示信息窗体
      // this.infoWindow.open(this.map, this.marker.getPosition());

      // this.marker.on("click", () => {
      //   this.infoWindow.open(this.map, this.marker.getPosition());
      // });
    },
    /** 回调函数 地图渲染好时触发 不需要可以删掉 */
    onAPILoaded() {
      this.loaded = true;
      console.log("执行对地图的其他操作");
      // 在这里可以执行其他与地图相关的操作
    },
    moment,
    /* 默认展示数据发生改变*/
    changeChartData(index, list) {
      index.forEach((item) => {
        this.chartData.push(list[item]);
      });
    },
    /* 右侧曲线没有IOT数据时展示蒙层，点击跳转服务请求页面 */
    toServcePage() {
      this.$router.push({
        path: "/repair-request/add",
        query: { id: this.equip_data.customer_id, sn: this.equip_data.root_sn },
      });
    },
    recursionArr(data) {
      let result = [];
      let num = 0;
      let queue = data;
      while (queue.length > 0) {
        num += 1;
        [...queue].forEach((child, i) => {
          queue.shift();
          child.index = i;
          child.num = num;
          child.iconType = true;
          child["subId"] = "a" + child.id;
          result = result.concat([child]);
          child.children && queue.push(...child.children);
        });
      }

      return result.filter((item) => {
        return item.num == 1;
      });
    },
    chooseInput(type) {
      this.currentChecked = type;
      this.selectCheckedList.forEach((select) => {
        if (type == select.type) {
          select.checked = true;
        } else {
          select.checked = false;
        }
      });
      //   this.toggleChecked();
    },
    toggleChecked() {
      this.option_show = !this.option_show;
    },
    randoms(min, max) {
      return parseFloat(Math.random() * (max - min) + min).toFixed(1);
    },
    /* 勾选状态 */
    saveInstancesSetting(data) {
      /* 遍历出投选状态下测点索引数组 */
      this.chartIndex = this.chartIndex.filter((item) => {
        return data.indexs.indexOf(item) == -1;
      });
      if (data.index_id.length > 0) {
        this.chartIndex = this.chartIndex.concat(data.index_id);
      }
      this.chartIndex = [...new Set(this.chartIndex)];
    },
    /* 置顶选项 */
    changeStarStat(list) {
      this.topIndex = this.sortedItems(list);
      // this.$emit("topIndexEvent", this.topIndex);
    },
  },
  components: {
    // Select,
    ShockData,
    Status,
    // cockpitTreeStar,
    cockpitTreeStarGroupPaperMaking,
  },
};
</script>

<style scoped lang="scss">
@import url("../../../../assets/scss/common.scss");
.right_select {
  .poninterNone {
    pointer-events: none;
  }
  .select_icon {
    width: 16px;
    background-size: cover;
    background-repeat: no-repeat;
    &.rotate {
      transform: rotate(180deg);
    }
  }
  .select_column {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    padding: 10px 20px;

    &:hover {
      cursor: pointer;
    }
  }
  .select_option {
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    box-sizing: border-box;
    z-index: 8;
    position: absolute;
    top: 100%;
    right: 100%;
    .option {
      padding: 10px 30px;
      &:nth-of-type(1) {
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
      }
      &:hover {
        cursor: pointer;
        background-color: #062323;
      }
    }
    .option_name {
      margin-left: 10px;
    }
  }
  .select_btn {
    font-weight: 700;
    padding: 8px;
    text-align: center;
    border-top: 2px solid #212121;
    color: #1cc9cb;
    &:hover {
      cursor: pointer;
    }
  }
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: opacity 0.8s;
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
}
.dashboard_right {
  // position: relative; //用于蒙层
  width: 400px;
  height: 100%;
  top: 0;
  right: 0;
  display: flex;
  flex-flow: column;
  .right_contain {
    flex: 1;
    .children {
      width: 100%;
      height: 95%;
      padding: 20px 20px 10px;
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 0 0 10px 10px;
      box-sizing: border-box;
      margin-bottom: 10px;
      &:nth-of-type(2n) {
        margin-bottom: 0px;
      }
      &.status {
        height: auto;
      }
    }
  }

  .dashboard-panel {
    min-height: 92px;
    display: flex;
    padding: 5px 0;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    margin-bottom: 10px;
    .electric,
    .pressure {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      padding: 10px 20px;
      box-sizing: border-box;
      .cont {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
        color: #00e7ff;
      }
      label {
        font-size: 16px;
      }
      .value,
      .unit {
        font-size: 20px;
      }
    }
  }
}
.dropdown_box {
  right: 405px !important;
  top: -40px !important;
}
//蒙层盒子 右侧曲线没有IOT数据时展示蒙层，点击跳转服务请求页
.overlay {
  position: absolute;
  top: 2px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(285, 286, 288, 0.6); /* 半透明黑色 */
  z-index: 1;
  // cursor: pointer; /* 可选：为蒙层添加鼠标指针样式 */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}
.scroll-model::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}
.scroll-model {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
